var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFea1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 94.023,
    height: 69.41,
    viewBox: "0 0 94.023 69.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1022",
    "data-name": "Group 1022",
    transform: "translate(-0.038 0.246)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1608",
    "data-name": "Path 1608",
    d: "M25,10.82c13.667,1.188,21.688,32.978,34.166,10.4-3.268-4.754-9.8-8.319-19.014-11.29,8.913-.3,15.746,2.08,19.906,7.427C56.492-3.738,44.906-5.818,25,10.82Z",
    transform: "translate(-17.545)",
    fill: "#ff8f3b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1609",
    "data-name": "Path 1609",
    d: "M150.377,20h0a2.663,2.663,0,0,1,2.674,2.674v31.79H148V22.674A2.427,2.427,0,0,1,150.377,20Z",
    transform: "translate(-104.002 -14.231)",
    fill: "#ff8f3b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1610",
    "data-name": "Path 1610",
    d: "M204.355,10.82c-13.667,1.188-21.688,32.978-34.166,10.4,3.268-4.754,9.507-8.319,18.717-11.29-8.913-.3-15.449,2.08-19.906,7.427C172.565-3.738,184.449-5.818,204.355,10.82Z",
    transform: "translate(-118.763)",
    fill: "#ff8f3b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1611",
    "data-name": "Path 1611",
    d: "M79.055,124.505c5.645-10.7,19.311-.3,13.667,10.7Q74.45,146.342,5.375,136.983c-7.725-2.377-6.833-16.043,1.188-16.637,0-12.775,15.152-15.152,18.123-2.971C24.092,104.3,38.65,99.549,43.7,110.542c5.942-11.587,20.2-10.7,25.253,1.188C76.084,104.9,85.294,116.781,79.055,124.505Z",
    transform: "translate(0 -72.092)",
    fill: "#ff8f3b",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFea1);
export default __webpack_public_path__ + "static/media/fea1.f833e70b0034806ce56cdf0e67dcb5ab.svg";
export { ForwardRef as ReactComponent };